import type { CountdownParts } from "./countdown.types";

const emptyParts: CountdownParts = {
  years: 0,
  months: 0,
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  completed: true,
};

function addYears(date: Date, years: number): Date {
  const copy = new Date(date);
  copy.setFullYear(copy.getFullYear() + years);
  return copy;
}

function addMonths(date: Date, months: number): Date {
  const copy = new Date(date);
  copy.setMonth(copy.getMonth() + months);
  return copy;
}

function addDays(date: Date, days: number): Date {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
}

export function getCountdownParts(
  eventAt: string,
  now: Date = new Date(),
): CountdownParts {
  const target = new Date(eventAt);

  if (Number.isNaN(target.getTime()) || target <= now) {
    return emptyParts;
  }

  let cursor = new Date(now);
  let years = target.getFullYear() - cursor.getFullYear();

  if (addYears(cursor, years) > target) {
    years -= 1;
  }

  cursor = addYears(cursor, years);

  let months =
    (target.getFullYear() - cursor.getFullYear()) * 12 +
    target.getMonth() -
    cursor.getMonth();

  if (addMonths(cursor, months) > target) {
    months -= 1;
  }

  cursor = addMonths(cursor, months);

  let days = Math.floor(
    (target.getTime() - cursor.getTime()) / 86_400_000,
  );

  if (addDays(cursor, days) > target) {
    days -= 1;
  }

  cursor = addDays(cursor, days);

  let remainder = target.getTime() - cursor.getTime();

  const hours = Math.floor(remainder / 3_600_000);
  remainder -= hours * 3_600_000;

  const minutes = Math.floor(remainder / 60_000);
  remainder -= minutes * 60_000;

  const seconds = Math.floor(remainder / 1_000);

  return {
    years,
    months,
    days,
    hours,
    minutes,
    seconds,
    completed: false,
  };
}

export function formatCountdownDate(eventAt: string): string {
  return new Intl.DateTimeFormat("en-MY", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(eventAt));
}